import { useQuery } from 'react-query';
import { getUserAvatarAPI } from '@myme/api';
import { getUserAvatar } from '@myme/logic';
import { useAuth } from 'src/hooks';

export const placeholderAvatar = '/images/default_profile_picture.jpg';

export const useGetUserAvatar = () => {
  const { isAuthenticated } = useAuth();

  const userAvatar = useQuery(
    getUserAvatarAPI.cacheKeys,
    async () => {
      const { data } = await getUserAvatar();

      return data;
    },
    {
      enabled: isAuthenticated
    }
  );

  return userAvatar.data?.profileImgUrl || placeholderAvatar;
};
